import React from 'react'
import './newsletter.css'

export default function Newsletter(){
  return (
    <div className='newsletter'>
        <h1>Get Exclusive Offers On Your Email</h1>
        <p>Subscribe to our newsletters and stay updated</p>
        <div>
        <input type="email" name="" id="" placeholder='Your Email id'/>
        <button>Subscribe</button>
    </div>
    </div>

  )
}
